import { useState, useEffect } from 'react';
import { apiClient } from '../../../../services/apiClient';

export const useObjectDateAttributes = (activeFile, objectType) => {
  const [dateAttributes, setDateAttributes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!activeFile || !objectType) {
      setDateAttributes([]);
      return;
    }
    let cancelled = false;
    setLoading(true);
    apiClient
      .get('/ocel/object-type-attributes', {
        params: { file_type: activeFile, object_type: objectType },
      })
      .then((res) => {
        if (cancelled) return;
        const detected = res.data?.date_attributes || [];
        setDateAttributes(detected.length > 0 ? detected : (res.data?.attributes || []));
      })
      .catch(() => {
        if (!cancelled) setDateAttributes([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [activeFile, objectType]);

  return { dateAttributes, loading };
};
